/**
 * Ryan O'Dowd
 * 2024-10-09
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({windowWidthRaw, windowHeight}) => {
  return {
    container: {
      position: 'absolute',
      top: 0,
      left: 0,
      flex: 1,
      width: windowWidthRaw,
      height: windowHeight,
      alignItems: 'center',
      justifyContent: 'center',
    },
    backgroundImageWrapper: {
      flex: 1,
      width: '100%',
    },
    rain: {
      width: windowWidthRaw,
      height: windowHeight,
    },
  };
};

export default getStyles;
